import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

// Session guard: responses from a previous login session (epoch) or a previously active business are dropped,
// so late replies can never overwrite the current user's/business's permissions or screen data.
const session = { epoch: 0, bid: "" };
export const setApiBusiness = (bid) => { session.bid = bid || ""; };
export const resetApiSession = () => { session.epoch += 1; session.bid = ""; };
export const currentApiBusiness = () => session.bid;

api.interceptors.request.use((config) => {
  config._epoch = session.epoch;
  if (config.headers["X-Business-Id"]) {
    config._explicitBid = true;
  } else if (session.bid) {
    config.headers["X-Business-Id"] = session.bid;
  }
  config._bid = config.headers["X-Business-Id"] || "";
  return config;
});

const isStale = (c) => !!c && (c._epoch !== session.epoch || (!c._explicitBid && c._bid !== session.bid));
const NEVER = () => new Promise(() => {});

// On an expired access token (401), silently refresh once via the refresh-token
// cookie and retry the original request. A single-flight promise prevents a refresh
// stampede when several requests 401 together during navigation. If refresh itself
// fails (truly expired/invalid session), fall back to the login screen.
let refreshing = null;
api.interceptors.response.use(
  (res) => (isStale(res.config) ? NEVER() : res),
  async (error) => {
    const original = error.config || {};
    if (isStale(error.config)) return NEVER();
    const status = error.response?.status;
    const url = original.url || "";
    const isAuthCall = url.includes("/auth/");
    if (status === 401 && !original._retry && !isAuthCall) {
      original._retry = true;
      try {
        if (!refreshing) {
          refreshing = api.post("/auth/refresh").finally(() => { refreshing = null; });
        }
        await refreshing;
        return api(original);
      } catch (e) {
        // network hiccup (mobile resume, weak signal) is NOT a logout; only a real auth rejection is
        const st = e?.response?.status;
        if ((st === 401 || st === 403) && typeof window !== "undefined" && !window.location.pathname.startsWith("/login")) {
          window.location.assign("/login");
        }
        return Promise.reject(e);
      }
    }
    return Promise.reject(error);
  }
);

export function apiErr(e) {
  if (e?.isAxiosError && !e.response) return "Sunucuya ulaşılamıyor, lütfen tekrar deneyin.";
  const detail = e?.response?.data?.detail;
  if (detail == null) return e?.message || "Bir hata oluştu";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((x) => (x && typeof x.msg === "string" ? x.msg : JSON.stringify(x))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
